export class ForgotPasswordModel {
    email: string;
}
